import { render, staticRenderFns } from "./uploadPictures.vue?vue&type=template&id=cb6c2a6c&scoped=true"
import script from "./uploadPictures.vue?vue&type=script&lang=js"
export * from "./uploadPictures.vue?vue&type=script&lang=js"
import style0 from "./uploadPictures.vue?vue&type=style&index=0&id=cb6c2a6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6c2a6c",
  null
  
)

export default component.exports